module.exports = __webpack_public_path__ + "static/media/10.eaf4328b.JPG";